import { createFormHook } from '@tanstack/react-form';
import { Checkbox } from '@new/common/ui/Checkbox/Checkbox';
import { PasswordInput } from '@new/common/ui/PasswordInput/PasswordInput';
import { Input } from '@new/common/ui/Input/Input';
import { Select } from '@new/common/ui/Select/Select';
import { Textarea } from '@new/common/ui/Textarea/Textarea';
import { SubmitButton } from '@new/common/ui/SubmitButton/SubmitButton';
import { fieldContext, formContext } from './form-context';
import { createFormField } from './createFormField';

export const { useAppForm, withForm, withFieldGroup } = createFormHook({
  fieldComponents: {
    Text: createFormField(Input<string>, 'text'),
    Email: createFormField(Input<string>, 'email'),
    Number: createFormField(Input<number>, 'number'),
    Password: createFormField(PasswordInput, 'password'),
    Checkbox: createFormField(Checkbox),
    Textarea: createFormField(Textarea<string>, 'text'),
    Select: createFormField(Select<string>),
  },
  formComponents: { SubmitButton },
  fieldContext,
  formContext,
});
